import { useState, useEffect } from "react";

const useFetchFormDataById = (id, formFields, fetchById, setValuesParent) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refetch, setRefetch] = useState(false);
  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchById(id);
        if ((res?.data?.success || res?.success) && (res.data.data || res.data)) {
          const data = res.data.data || res.data;
          const fetchedValues = {};
          formFields.forEach((field) => {
            fetchedValues[field.name] = data[field.name] ?? "";
            if (field.type === "file" && data[`${field.name}_url`]) {
              fetchedValues[`${field.name}Preview`] = data[`${field.name}_url`];
            }
          });
          if (setValuesParent) setValuesParent(fetchedValues);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, formFields, fetchById, setValuesParent, refetch]);

  return { loading, error, setRefetch };
};

export default useFetchFormDataById;
